<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>我的卡券</h1>
        <p>卡券逐张持有与兑换。一张券一个兑换码，兑换码在明细里查看。已兑换积分只统计已核销券。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="$router.push('/partner/recharge')">获取代金券</button>
      </div>
    </div>
    <div class="ch-metrics five">
      <div class="ch-metric"><div class="k">可用代金券</div><div class="v">{{ unused.length }} 张</div><div class="s">未使用 {{ unused.length }} · 已使用 {{ used.length }} · 已过期 {{ expired.length }}</div></div>
      <div class="ch-metric"><div class="k">可用代金券面额</div><div class="v">¥ {{ yuan(unusedFace) }}</div><div class="s">按未使用券面值合计</div></div>
      <div class="ch-metric"><div class="k">已兑换积分</div><div class="v">{{ usedPoints.toLocaleString() }} 分</div><div class="s">面值 1 元按 10 积分计</div></div>
      <div class="ch-metric"><div class="k">30 天内到期</div><div class="v">{{ soon.length }} 张</div><div class="s">{{ soonText }}</div></div>
      <div class="ch-metric"><div class="k">本月新增</div><div class="v">{{ monthNew }} 张</div><div class="s">购买 {{ monthBuy }} · 申请 {{ monthApply }} · 总部 {{ monthGrant }}</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <select v-model="source">
          <option value="">来源：全部</option>
          <option value="PURCHASE">购买</option>
          <option value="APPLY">申请审批</option>
          <option value="GRANT">总部划拨</option>
        </select>
        <select v-model="state">
          <option value="">状态：全部</option>
          <option value="UNUSED">未使用</option>
          <option value="USED">已使用</option>
          <option value="EXPIRED">已过期</option>
          <option value="REJECTED">已驳回</option>
          <option value="PENDING_PAY">待确认到账</option>
          <option value="PENDING_REVIEW">待审批</option>
        </select>
        <span class="ch-note" style="padding:6px 10px">共 {{ shown.length }} 张 · 一行一张券</span>
      </div>
      <table class="ch-table">
        <thead><tr><th>券编号</th><th>面值</th><th>来源</th><th>申请时间</th><th>获取时间</th><th>使用时间</th><th>有效期</th><th>状态</th><th>驳回原因</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in shown" :key="row.id">
            <td>{{ row.id }}</td>
            <td>¥ {{ yuan(row.faceValue) }}</td>
            <td>{{ statusName(row.source) }}</td>
            <td>{{ clock(row.createdAt) }}</td>
            <td>{{ clock(row.acquiredAt) }}</td>
            <td>{{ clock(row.usedAt) }}</td>
            <td>{{ row.expireAt || '—' }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ statusName(row.status) }}</span></td>
            <td>{{ row.rejectReason || '—' }}</td>
            <td>
              <button class="ch-link" type="button" @click="detail = row">明细</button>
              <button v-if="canUse(row)" class="ch-link" type="button" @click="use(row)">立即使用</button>
            </td>
          </tr>
          <tr v-if="!shown.length"><td colspan="7" class="ch-empty">还没有代金券</td></tr>
        </tbody>
      </table>
      <p v-if="eco" class="ch-note" style="margin-top:12px">未使用的券可以点「立即使用」兑进积分池，1 元面值入账 10 积分。兑进积分池后，这张券不能再给会员兑换。</p>
      <p v-else class="ch-note" style="margin-top:12px">代金券兑换由 C 端扣费，不计入返佣。兑换码按券独立生成，不在列表里直接展示。</p>
    </div>
    <el-dialog title="券明细" :visible.sync="detailOpen" width="420px">
      <div v-if="detail" class="ch-kv">
        <span>券编号</span><b>{{ detail.id }}</b>
        <span>面值</span><b>¥ {{ yuan(detail.faceValue) }}</b>
        <span>应付</span><b>{{ detail.payAmount != null ? '¥ ' + yuan(detail.payAmount) : '—' }}</b>
        <span>兑换码</span><b>{{ detail.redeemCode || '待发放' }}</b>
        <span>来源</span><b>{{ statusName(detail.source) }}</b>
        <span>状态</span><b>{{ statusName(detail.status) }}</b>
        <span>驳回原因</span><b>{{ detail.rejectReason || '—' }}</b>
        <span>申请时间</span><b>{{ clock(detail.createdAt) }}</b>
        <span>获取时间</span><b>{{ clock(detail.acquiredAt) }}</b>
        <span>使用时间</span><b>{{ clock(detail.usedAt) }}</b>
        <span>有效期</span><b>{{ detail.expireAt || '—' }}</b>
        <span>兑换用户</span><b>{{ detail.usedByUserId || '—' }}</b>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelVouchers, useEcoVoucher } from '@/api/admin'
import { statusName, yuan } from './labels'

export default {
  name: 'PartnerVouchers',
  data() {
    return { list: [], source: '', state: '', detail: null }
  },
  computed: {
    detailOpen: {
      get() { return !!this.detail },
      set(v) { if (!v) this.detail = null }
    },
    unused() { return this.list.filter(item => item.status === 'UNUSED') },
    used() { return this.list.filter(item => item.status === 'USED') },
    expired() { return this.list.filter(item => item.status === 'EXPIRED') },
    unusedFace() { return this.unused.reduce((sum, item) => sum + Number(item.faceValue || 0), 0) },
    usedPoints() { return this.used.reduce((sum, item) => sum + Math.round(Number(item.faceValue || 0) * 10), 0) },
    soon() {
      const limit = Date.now() + 30 * 86400000
      return this.unused.filter(item => item.expireAt && new Date(item.expireAt).getTime() <= limit)
    },
    soonText() { return this.soon.length ? this.soon.map(item => item.id).slice(0, 2).join('、') : '暂无' },
    monthKey() { return new Date().toISOString().slice(0, 7) },
    monthRows() { return this.list.filter(item => String(item.createdAt || '').indexOf(this.monthKey) === 0) },
    monthNew() { return this.monthRows.length },
    monthBuy() { return this.monthRows.filter(item => item.source === 'PURCHASE').length },
    monthApply() { return this.monthRows.filter(item => item.source === 'APPLY').length },
    monthGrant() { return this.monthRows.filter(item => item.source === 'GRANT').length },
    eco() {
      return this.$parent && this.$parent.levelCode === 'ECO'
    },
    shown() {
      return this.list.filter(item => (!this.source || item.source === this.source) && (!this.state || item.status === this.state))
    }
  },
  created() { this.load() },
  methods: {
    statusName, yuan,
    clock(value) {
      if (!value) return '—'
      return String(value).replace('T', ' ').slice(0, 19)
    },
    tagOf(status) {
      if (status === 'UNUSED' || status === 'USED') return 'ok'
      if (status === 'EXPIRED' || status === 'REJECTED') return 'bad'
      if (status === 'PENDING_PAY' || status === 'PENDING_REVIEW') return 'warn'
      return 'muted'
    },
    canUse(row) {
      if (!this.eco || !row || row.status !== 'UNUSED') return false
      if (!row.expireAt) return true
      const day = String(row.expireAt).slice(0, 10)
      const now = new Date()
      const today = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0')
      return day >= today
    },
    async use(row) {
      const points = Math.round(Number(row.faceValue || 0) * 10)
      try {
        await this.$confirm('把这张 ¥' + this.yuan(row.faceValue) + ' 的代金券兑进积分池？将入账 ' + points.toLocaleString() + ' 积分，券变为已使用。', '立即使用', { type: 'warning' })
      } catch (e) {
        return
      }
      const result = await useEcoVoucher(row.id)
      this.$message.success('已入积分池 ' + Number((result && result.points) || points).toLocaleString() + ' 积分')
      this.load()
    },
    async load() {
      const vouchers = await getChannelVouchers()
      this.list = vouchers.list || []
    }
  }
}
</script>
